exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.smart-search-results { \n    display: block;\n    position: absolute;\n    width: 350px;\n    height: auto;\n    max-height: 600px;\n    background-color: white;\n    overflow-y: auto;\n    border: solid 1px lightgray;\n    z-index: 99;\n    right: 75px;\n}\n.smart-search-results--group-label {\n    font-size: 1.2rem;\n    font-weight: bold;\n}\n.close-button {\n   position: absolute;\n   top: 0;\n   right: 0;\n}\n.suboption-button {\n}\n", ""]);

// exports
